import React, { createContext, useContext, useState, useCallback } from 'react';

interface BugReportContextType {
  isOpen: boolean;
  openBugReport: (customContext?: { entity_type?: string; entity_id?: string }) => void;
  closeBugReport: () => void;
  contextHint?: { entity_type?: string; entity_id?: string };
}

const BugReportContext = createContext<BugReportContextType | undefined>(undefined);

export const BugReportProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [contextHint, setContextHint] = useState<{ entity_type?: string; entity_id?: string } | undefined>(undefined);

  const openBugReport = useCallback((customContext?: { entity_type?: string; entity_id?: string }) => {
    setContextHint(customContext);
    setIsOpen(true);
  }, []);

  const closeBugReport = useCallback(() => {
    setIsOpen(false);
    setContextHint(undefined);
  }, []);

  return (
    <BugReportContext.Provider value={{ isOpen, openBugReport, closeBugReport, contextHint }}>
      {children}
    </BugReportContext.Provider>
  );
};

export const useBugReport = (): BugReportContextType => {
  const context = useContext(BugReportContext);
  if (!context) {
    throw new Error('useBugReport must be used within a BugReportProvider');
  }
  return context;
};
